module.exports = __webpack_public_path__ + "static/header-home-3d18b117ae03558d290ac16340b963c3.jpg";